import { http, HttpResponse, type HttpHandler } from "msw";

import { API_PREFIX } from "@nasam/kernel";
import type { SellableModuleDto } from "../data";
import { sellingPriceWriteDtoSchema } from "../data";
import {
  catalogModuleCapacities,
  catalogSellableModules,
} from "./catalogFixtures";

const MODULES_PATH = `${API_PREFIX}/modules`;

export interface CatalogHandlerOptions {
  readonly apiBaseUrl: string;
}

export function createCatalogHandlers({
  apiBaseUrl,
}: CatalogHandlerOptions): readonly HttpHandler[] {
  let modules = catalogSellableModules.map((module) => ({ ...module }));

  return [
    // No query params at all -- the seller is read from the token, and this
    // is the caller's own holdings, not the global catalogue.
    http.get(`${apiBaseUrl}${MODULES_PATH}/sellable`, () =>
      HttpResponse.json({ data: modules }),
    ),

    http.get(`${apiBaseUrl}${MODULES_PATH}/capacity`, () =>
      HttpResponse.json({ data: catalogModuleCapacities }),
    ),

    http.patch(
      `${apiBaseUrl}${MODULES_PATH}/:id/selling-price`,
      async ({ params, request }) => {
        const body = sellingPriceWriteDtoSchema.parse(await request.json());
        const index = modules.findIndex((module) => module.id === params.id);

        if (index === -1) {
          return HttpResponse.json(
            {
              statusCode: 404,
              path: `${MODULES_PATH}/${String(params.id)}/selling-price`,
              message: "You don't currently hold this module",
            },
            { status: 404 },
          );
        }

        const current = modules[index] as SellableModuleDto;
        const updated: SellableModuleDto = {
          ...current,
          sellingPrice: body.sellingPrice,
          updatedAt: "2026-02-01T10:00:00.000Z",
        };
        modules = modules.with(index, updated);
        return HttpResponse.json({ data: updated });
      },
    ),
  ];
}
